import { FileCode2, Home, Mail } from "lucide-react";
import ContactsIndex from "../pages/contacts";
import ExperienceIndex from "../pages/experience";
// import GalleryIndex from "../pages/gallery";
import HomeIndex from "../pages/home";

export const MENU_PATHS = {
  HOME: "/",
  EXPERIENCE: "/experience",
  CONTACTS: "/contacts",
  GALLERY: "/gallery",
};

const MENU = [
  {
    label: "Home",
    icon: <Home className="h-5 w-5" strokeWidth={1.6} />,
    path: MENU_PATHS.HOME,
    element: <HomeIndex />,
  },
  {
    label: "Skill",
    icon: <FileCode2 className="h-5 w-5" strokeWidth={1.6} />,
    path: MENU_PATHS.EXPERIENCE,
    element: <ExperienceIndex />,
  },
  // {
  //   label: "Gallery",
  //   icon: <ImageIcon className="h-5 w-5" strokeWidth={1.6} />,
  //   path: MENU_PATHS.GALLERY,
  //   element: <GalleryIndex />,
  // },
  {
    label: "Contact",
    icon: <Mail className="h-5 w-5" strokeWidth={1.6} />,
    path: MENU_PATHS.CONTACTS,
    element: <ContactsIndex />,
  },
];

export default MENU;
